import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { DEFAULT_LOCALE, isRtlLocale, isSupportedLocale } from './languages';
import { readSettingsBlob } from '@/lib/settingsStore';
import en from './locales/en.json';
import zh from './locales/zh.json';
import hi from './locales/hi.json';
import es from './locales/es.json';
import fr from './locales/fr.json';
import ar from './locales/ar.json';
import bn from './locales/bn.json';
import pt from './locales/pt.json';
import ru from './locales/ru.json';
import id from './locales/id.json';

// Read the persisted locale synchronously so the first paint is already in the
// right language. Tolerate the legacy PascalCase `Locale` key, mirroring the
// ThemeProvider's handling of the same blob.
function initialLocale(): string {
  const blob = readSettingsBlob();
  const raw = blob.locale ?? blob.Locale;
  return isSupportedLocale(raw) ? raw : DEFAULT_LOCALE;
}

const lng = initialLocale();

void i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    zh: { translation: zh },
    hi: { translation: hi },
    es: { translation: es },
    fr: { translation: fr },
    ar: { translation: ar },
    bn: { translation: bn },
    pt: { translation: pt },
    ru: { translation: ru },
    id: { translation: id },
  },
  lng,
  fallbackLng: DEFAULT_LOCALE,
  interpolation: { escapeValue: false },
  returnNull: false,
  returnEmptyString: false,
});

// Reflect the active locale onto <html lang> + <html dir> so the document reads
// out correctly and Arabic flips to RTL.
export function applyDocumentLocale(code: string): void {
  const html = document.documentElement;
  html.lang = code;
  html.dir = isRtlLocale(code) ? 'rtl' : 'ltr';
}

applyDocumentLocale(lng);

export default i18n;
